// src/pages/InkapprenticeTV.jsx
import React, { useEffect, useRef } from "react";
import "./InkapprenticeTV.css";

export default function InkapprenticeTV() {
  const cardVideosRef = useRef([]);

  const videoData = [
    {
      id: 1,
      poster: "https://cosacademyassets.s3.us-east-2.amazonaws.com/EP1.jpg",
      link: "https://cosacademyassets.s3.us-east-2.amazonaws.com/EP1Clip.mp4",
      link2: "https://cosacademyassets.s3.us-east-2.amazonaws.com/EP1.mp4",
    },
    {
      id: 2,
      poster: "https://cosacademyassets.s3.us-east-2.amazonaws.com/EP2.jpg",
      link: "https://cosacademyassets.s3.us-east-2.amazonaws.com/EP2Clip.mp4",
      link2: "https://cosacademyassets.s3.us-east-2.amazonaws.com/EP2.mp4",
    },
    {
      id: 3,
      poster: "https://cosacademyassets.s3.us-east-2.amazonaws.com/EP3.jpg",
      link: "https://cosacademyassets.s3.us-east-2.amazonaws.com/EP3Clip.mp4",
      link2: "https://cosacademyassets.s3.us-east-2.amazonaws.com/EP3.mp4",
    },
    {
      id: 4,
      poster: "https://cosacademyassets.s3.us-east-2.amazonaws.com/EP4.jpg",
      link: "https://cosacademyassets.s3.us-east-2.amazonaws.com/EP4Clip.mp4",
      link2: "https://cosacademyassets.s3.us-east-2.amazonaws.com/EP4.mp4",
    },
  ];

  // autoplay/pause when in view
  useEffect(() => {
    const vids = cardVideosRef.current.filter(Boolean);
    if (!vids.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const vid = entry.target;
          if (entry.isIntersecting) {
            vid.muted = true;
            vid.playsInline = true;
            const p = vid.play();
            if (p && p.catch) p.catch(() => {});
            vid.classList.add("is-active");
          } else {
            vid.pause();
            vid.classList.remove("is-active");
          }
        });
      },
      { threshold: 0.4 }
    );

    vids.forEach((v) => io.observe(v));
    return () => {
      vids.forEach((v) => io.unobserve(v));
      io.disconnect();
    };
  }, []);

  return (
    <section className="inktv-section">
      {/* ===== HEADER ===== */}
      <header className="inktv-header">
        <div className="inktv-header-top">
          <div className="inktv-badge">COSMETINK® ORIGINAL SERIES</div>

          <div className="inktv-title-row">
            <span className="inktv-title-ink moving-grad">INK</span>
            <span className="inktv-title-rest"> APPRENTICE™ &nbsp;TV</span>
          </div>

          <div className="inktv-header-glowbar" />
        </div>

        <div className="inktv-header-copy">
          <div className="inktv-hook">Think you can INK?</div>
          <p className="inktv-desc">Watch future PMU artists become artists — on camera.</p>
        </div>
      </header>

      {/* ===== GRID ===== */}
      <div className="inktv-grid">
        {videoData.map((video, idx) => (
          <div className="inktv-grid-cell" key={video.id}>
            <article
              className="inktv-card fadepop"
              style={{ "--delay": `${idx * 80}ms` }}
            >
              {/* EP badge */}
              <div className="inktv-ep-chip">EP {String(video.id).padStart(2, "0")}</div>

              {/* frame */}
<div className="inktv-shadow">
  <div className="inktv-frame">
    <div className="inktv-frame-gradient" />

    <video
      className="inktv-vid"
      src={video.link}
      poster={video.poster}
      muted
      playsInline
      loop
      autoPlay
      ref={(el) => (cardVideosRef.current[idx] = el)}
    />

    {/* overlay CTA ON TOP OF THE VIDEO */}
    <a
      className="inktv-cta inktv-cta--overlay"
      href={video.link2 || video.link}
      target="_blank"
      rel="noopener noreferrer"
    >
      View Episode
      <span className="inktv-cta-underline" />
    </a>

    {/* Full-frame click layer (keep it under the CTA) */}
    <a
      className="inktv-hit"
      href={video.link2 || video.link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Play Episode ${video.id}`}
    />
  </div>
</div>

           
                   
            </article>
          </div>
        ))}
      </div>
      
    </section>
  );
}
